<template>
    <div>
        <div class="brand-nav">
            <div class="brand-wrapper">
                <div class="brand">
                    <img src="@/assets/logo.png" alt="">
                </div>
                <div class="right-border"></div>
                <h2>Love Economy <br>Church</h2>
            </div>

            <div class="theme">Our year of <br><span>the Spirit</span></div>
        </div>

        <div class="content">
            <div class="year">2020</div>
            <h1>LEADERS<br>CAMP</h1>
            <div class="error-box" >{{error}}</div>
            <div class="login-input">
                <span class="fe-mail"></span>
                <input type="text" placeholder="Enter email to login" v-model="email">

                <div class="submit-btn" v-if="submitting"> <loader/> </div>
                <div class="submit-btn" @click="login" v-else>Login <span class="fe-arrow-right"></span></div>
            </div>
        </div>
    </div>
</template>

<script>
    import Loader from '@/components/loader.vue'

    export default {
        components: {
            Loader
        },
        data(){
            return {
                submitting: false,
                error: null,

                email: ''
            }
        },
        methods: {
            login(){
                this.error = null
                this.submitting = true
                let email = this.email.toLowerCase();

                this.$http.post('signin', {email: email})
                .then(res => {
                    console.log(res.body)
                    localStorage.setItem('access_token', res.body.token)
                    localStorage.setItem('user', JSON.stringify(res.body.user))
                    this.$store.commit('SET_SESSION')
                    this.submitting = false
                    this.$router.push({name: 'dashboard-home'})
                })
                .catch(err => {
                    console.log(err)
                    if(err.body){
                        this.error = err.body.error
                    }
                    this.submitting =  false;
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .brand-nav{
        // padding: 30px;
        width: 100%;
        box-sizing: border-box;

        .brand{
            width: 60px;
            img{
                width: 100%;
                vertical-align: inherit;
            }
            display: inline-block;
            margin-right: 10px;
        }
        .right-border{
            width: 2px;
            height: 60px;
            background-color: #1d227b;
            display: inline-block;
            vertical-align: sub;
        }
        h2{
            display: inline-block;
            margin-top: 0;
            margin-left: 10px;
            text-transform: uppercase;
            font-family: Arial;
            font-size: 20px;
            margin-bottom: 10px;
            vertical-align: bottom;
            color: #1d227b;
        }
    }

    .brand-wrapper{
        padding: 30px;
        display: inline-block;
    }

    .theme{
        float: right;
        background-color: rgb(255, 81, 0);
        height: 100px;
        width: 200px;
        padding: 20px;
        box-sizing: border-box;
        color: yellow;
        text-transform: uppercase;
        font-family: Arial;
        font-size: 13px;
        span{
            text-transform: capitalize;
            margin-left: 20px;
            line-height: 50px;
            font-family: 'Bilbo';
            font-size: 3em;
        }
    }

    @media screen and (max-width: 508px) {
        .theme{
            display: block;
            float: none;
            width: 100%;
            font-size: 13px;
            padding: 7px 30px !important;
            height: 80px;
            span{
                margin-left: 80px
            }
        }

        .content{
            width: auto !important;
            padding: 10px 20px;
            .year{
                float: right;
                letter-spacing: 15px !important;
                clear: both;
            }
            h1{
                font-size: 1.8em !important;
                letter-spacing: 20px !important;
            }
            .login-input{
                height: 40px !important;
                width: 100% !important;
                span{
                    color:#1d227b;
                    font-size: 20px !important;
                    line-height: 20px !important;
                }
                input{
                    font-size: 18px !important;;
                    line-height: 19px !important;
                }
            }
        }

        // .brand-wrapper{
        //     width: 300px;
        //     display: block;
        //     margin: 0 auto;
        // }
        
    }

    .content{
        width: 500px;
        margin: 40px auto 0 auto;
        h1{
            font-size: 4em;
            font-weight: bold;
            font-family: Arial;
            letter-spacing: 20px;
            margin-top: 10px;
            color: #0f1250;
        }
        .year{
            color:  rgb(255, 81, 0);;
            letter-spacing: 20px;
            font-family: Arial;
            font-weight: bold;
            text-align: left;
            margin-left: 4px;
        }

        .error-box{
            color: rgb(243, 56, 56);
            font-weight: 500;
            font-size: 19px;
            margin-bottom: 10px;
        }

        .login-input{
            width: calc(100% - 50px);
            height: 50px;
            background-color: yellow;
            border-radius: 25px;
            padding: 10px;
            span{
                color:#1d227b;
                font-size: 28px;
                line-height: 28px;
                margin-right: 10px;
                &:first-child{
                    font-size: 20px;
                    margin-left: 10px;
                }
                &:last-child{
                    cursor: pointer;
                }
            }
            input{
                background-color: transparent;
                border: none;
                margin-left: 10px;
                font-size: 21px;
                outline: none;
                color:#1d227b;
                line-height: 27px;
                &::placeholder{
                    color: #1d227ba4
                }
            }
        }
        .submit-btn{
            width: 130px;
            margin-left: auto;
            margin-top: 20px;
            background-color: #1d227b;
            text-align: center;
            color: white;
            padding: 10px 20px;
            font-family: Arial, Helvetica, sans-serif;
            border-radius: 25px;
            cursor: pointer;
            span{
                color: white;
            }
        }
    }

    @media screen and (min-width: 1200px){
      .show-lg-only{
        display: inline-block;
      }
    }

    @media screen and (min-width: 500px){
      .show-md{
        display: inline-block;
      }
    }

     @media screen and (min-width: 750px){
      .show-mmd{
        display: inline-block;
      }
    }

    @media screen and (max-width: 500px){
      .show-sm-only{
        display: block;
      }
      .hide-sm{
        display: none;
      }
      .theme{
        font-size: 15px !important;
      }
      .sidebar{
        display: none;
      }
      .main-wrapper{
        width: 100% !important;
      }
    }
</style>